/**
 * Created by 唐亦慧 on 2017/8/31.
 */
import Reflux from 'reflux';

export const peopleActions = Reflux.createActions([
	'paramChange',
	'useStoreChange'
]);

export class peopleStore extends Reflux.Store {
	constructor() {
		super();
		this.state = {
				useStore: false,
				storeData:{
					p:1,
					s:10,
					account:'',
					name:'',
					status:''
				}
		}
		this.listenables = peopleActions;
	}
	
	useStoreChange(flag){
		this.setState({
			...this.state,
			useStore: flag
		});
	}
	paramChange(data){
		this.setState({
			...this.state,
			storeData:{
				...this.state.storeData,
				...data
			}
		});
	}
}


// WEBPACK FOOTER //
// ./src/routes/people/store.js